<template>
  <div class="app-header">
    <div class="brand-row">
      <img class="brand-logo" src="@/assets/images/logo.png" alt=""/>
      <div class="header-brand">OP <span>Card<em>X</em></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables' as *;

.brand-row {
  display: flex;
  align-items: center;
  gap: 10px;

  .brand-logo {
    width: 42px;
    height: 44px;
  }

  .header-brand {
    font-family: $font-body;
    font-size: 20px;
    font-weight: 900;
    letter-spacing: 0.06em;
    color: $white;

    span { color: $gold; }
    em { color: $white; font-style: normal; }
  }
}
</style>